// Featured Collection Tab Navigation
document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(e) {
    const button = e.target.closest('.collection-carousel-nav button');
    if (!button) return;

    const parentCarousel = button.closest('.tabs--component');
    if (!parentCarousel) return;

    // Remove selected class from all buttons in this component
    parentCarousel.querySelectorAll('.collection-carousel-nav button').forEach(btn => {
      btn.classList.remove('selected');
    });

    // Add selected class to clicked button
    button.classList.add('selected');

    // Hide all carousels in this component
    parentCarousel.querySelectorAll('.collection-carousel').forEach(carousel => {
      carousel.classList.remove('selected');
    });

    // Show the selected carousel
    const index = button.getAttribute('data-index');
    const targetCarousel = document.getElementById(`collection-carousel--${index}`);
    if (targetCarousel) {
      targetCarousel.classList.add('selected');

      // Update the slider in the newly visible carousel
      const sliderComponent = targetCarousel.querySelector('keen-slider-component');
      if (sliderComponent && sliderComponent.update) {
        sliderComponent.update();
      }
    }
  });
});
